module.exports = __webpack_public_path__ + "img/smap1.29d4093e.png";